import socket from '@/plugins/socket'
import CompetitorQualify from '@/store/model/sport/sport/CompetitorQualify'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas = datas.sort((a, b) => a.shortnameFr.localeCompare(b.shortnameFr))
      datas.forEach(item => { state.list.push(new CompetitorQualify(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportCompetitorqualify', 'Sport/CompetitorQualify/set') }
  },
  getters: {
    list: (state) => state.list,
    get: (state) => (id) => state.list.find(item => item.id === id),
    getByDiscipline: (state) => (disciplineId) => state.list.filter(item => item.disciplineId === disciplineId)
  }
}
